// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".collapsed-settings__title strong[data-v-712d2406]{font-size:1.375em;font-weight:600 !important}@media only screen and (max-width: 768px){.collapsed-settings__title[data-v-712d2406]{font-size:16px}.collapsed-settings__title strong[data-v-712d2406]{font-size:16px;font-weight:400 !important}}.collapsed-settings__title__icon[data-v-712d2406]{position:relative;top:-3px;margin-right:8px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
